import React from 'react';
import { Image } from 'elements';
import strings from '../../../../utils/translationStrings';

import './ExpertiseSection.scss';

export const ExpertiseSection = () => {
  return (
    <section id="expertise" className="expertise">
      <div className="expertise__container">
        <div className="expertise__intro">
          <div className="expertise__intro--left">
            <h1>{strings.landing.expertise.title}</h1>
            <p>{strings.landing.expertise.slogan}</p>
          </div>
          <div className="expertise__intro--right">
            <p>{strings.landing.expertise.description}</p>
          </div>
        </div>
        <div className="expertise-details">
          <div className="expertise-details__item">
            <Image
              source="/resources/images/assets/planet.svg"
              height="152px"
              width="152px"
            />
            <p>{strings.landing.expertise.features.strategy.text}</p>
          </div>
          <div className="expertise-details__item">
            <Image
              source="/resources/images/assets/fraud.svg"
              height="152px"
              width="152px"
            />
            <p>{strings.landing.expertise.features.risk.text}</p>
          </div>
          <div className="expertise-details__item">
            <Image
              source="/resources/images/assets/bag.svg"
              height="152px"
              width="152px"
            />
            <p>{strings.landing.expertise.features.sell.text}</p>
          </div>
        </div>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Landing/Partial/ExpertiseSection/ExpertiseSection.js